import React, { FC, ChangeEvent, useState } from 'react';
import { withTranslation } from 'react-i18next';

import { BasicInput, SimplePopover, Checkbox } from '@dev/ee-components';
import styled from 'styled-components';

import { ExportFileFormats } from '@dev/ee-api/ee-api-models';
import Props from './ExportModalInterface';

const ModalContainer = styled.div<{ isMobile }>`
    min-width: ${({ isMobile }) => (isMobile ? '' : '26.25em')};
    font-size: 14px;

    & .MuiFormControlLabel-root {
        margin-top: 24px;
    }
`;
const Divider = styled.div`
    height: 16px;
`;

const ExportModal: FC<Props> = (props: Props): JSX.Element => {
    const { t, inputRef, isMobile } = props;
    const [isChecked, setIsChecked] = useState(true);

    return (
        <ModalContainer isMobile={isMobile}>
            <BasicInput label={t('filename')} inputRef={inputRef} />
            <Divider />
            <SimplePopover
                type="input"
                label={t('fileformat')}
                options={[
                    { label: 'CSV', value: ExportFileFormats.Csv },
                    { label: 'JSON', value: ExportFileFormats.Json },
                    { label: 'XML', value: ExportFileFormats.Xml },
                ]}
                fullWidth={true}
                defaultValue={ExportFileFormats.Csv}
                onItemClick={(ev: React.MouseEvent<HTMLElement>, value?: Record<string, unknown>): void => {
                    props.onFileFormatChange(value);
                }}
            />
            <Checkbox
                name="usezipcompression"
                label={t('usezipcompression')}
                checked={isChecked}
                onChange={(ev: ChangeEvent<HTMLInputElement>, checked?: boolean): void => {
                    props.onCompressionChange(checked);
                    setIsChecked(checked);
                }}
            />
        </ModalContainer>
    );
};

export default withTranslation()(ExportModal);
